var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register"},[_c('login-register',[_c('register-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }